export default __webpack_public_path__ + "static/media/placeholder_dummy2016-meditation01-mobile-de.6bf4e9f0.png";